import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { CustomTabs, CustomCollapse } from "../../components";
import { useGetHelpList } from "./hooks/help.hook";
import CommonIssues from "./components/CommonIssues";
import About from "./components/About";
import styles from "./style.module.scss";

function Help() {
  const [nowKey, setNowKey] = useState("about");
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const getHelpList = useGetHelpList({});
  const tabItems = [
    {
      key: "about",
      title: t("personal.help.about"),
    },
    {
      key: "commonIssues",
      title: t("personal.help.faqs"),
    },
  ];
  const contentDict = {
    about: <About data={getHelpList.data?.about} />,
    commonIssues: <CommonIssues data={getHelpList.data?.question} />,
  };

  const getNowTab = () => {
    const tab = params.get("tab");
    if (tab) {
      const foundTab = tabItems.find((item) => item.key == tab);
      if (foundTab) {
        setNowKey(tab);
      } else {
        setNowKey(tabItems[0].key);
      }
    } else {
      setNowKey(tabItems[0].key);
    }
  };

  useEffect(() => {
    getNowTab();
  }, []);

  return (
    <div className={styles.helpPage}>
      <CustomTabs
        tabItems={tabItems}
        activeKey={nowKey}
        onTabChange={(key) => {
          setNowKey(key);
        }}
      />
      <div className={styles.contentContainer}>{contentDict[nowKey]}</div>
    </div>
  );
}

export default Help;
